import React from "react";
import { Box, Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import StackedLineChartRoundedIcon from "@mui/icons-material/StackedLineChartRounded";
import { isDarkMode } from "../../../utils/constants";

const layerButtonSx = ({ active, isMobile }) => {
  const activeBg = isDarkMode
    ? "rgba(122,162,255,0.22)"
    : "rgba(37,99,235,0.16)";
  const inactiveBg = isDarkMode
    ? "rgba(255,255,255,0.08)"
    : "rgba(0,0,0,0.06)";
  const activeColor = isDarkMode ? "#a8c1ff" : "#1d4ed8";
  const inactiveColor = isDarkMode ? "rgba(229,231,235,0.62)" : "rgba(17,24,39,0.58)";

  return {
    width: isMobile ? 28 : 30,
    height: isMobile ? 28 : 30,
    borderRadius: "9px",
    position: "relative",
    overflow: "hidden",
    border: active
      ? `1px solid ${isDarkMode ? "rgba(122,162,255,0.32)" : "rgba(37,99,235,0.24)"}`
      : `1px solid ${isDarkMode ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)"}`,
    backgroundColor: active ? activeBg : inactiveBg,
    color: active ? activeColor : inactiveColor,
    transition: "background-color 140ms ease, border-color 140ms ease, color 140ms ease",
    "&:hover": {
      backgroundColor: active
        ? isDarkMode
          ? "rgba(122,162,255,0.3)"
          : "rgba(37,99,235,0.22)"
        : isDarkMode
          ? "rgba(255,255,255,0.13)"
          : "rgba(0,0,0,0.1)",
    },
    "&::after": active
      ? {}
      : {
          content: '""',
          position: "absolute",
          left: "50%",
          top: "50%",
          width: isMobile ? 17 : 18,
          height: "1.5px",
          borderRadius: "999px",
          backgroundColor: isDarkMode
            ? "rgba(229,231,235,0.72)"
            : "rgba(17,24,39,0.58)",
          pointerEvents: "none",
          transform: "translate(-50%, -50%) rotate(-42deg)",
        },
  };
};

const ChartLayerControls = ({
  showIndicators = true,
  onToggleIndicators,
  isMobile = false,
  sx = {},
}) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: isMobile ? 0.35 : 0.5,
      ...sx,
    }}
  >
    <Tooltip title={showIndicators ? "Indicators on" : "Indicators off"}>
      <IconButton
        size="small"
        aria-label={showIndicators ? "Hide indicators" : "Show indicators"}
        aria-pressed={showIndicators}
        onClick={onToggleIndicators}
        sx={layerButtonSx({ active: showIndicators, isMobile })}
      >
        <StackedLineChartRoundedIcon sx={{ fontSize: isMobile ? 16 : 17 }} />
      </IconButton>
    </Tooltip>
  </Box>
);

export default ChartLayerControls;
